import { makeStyles } from '@mui/styles';

import { drawerWidth } from '../../../constants';

const useStyles = makeStyles((theme) => ({
  container: {
    // minHeight: '100vh',
    // [theme.breakpoints.up('md')]: {
    //   width: '100%',
    //   marginLeft: 0,
    //   justifyContent: 'center',
    // },
  },
  containerInner: {
    // [theme.breakpoints.up('md')]: {
    //   // maxWidth: '1424px',
    //   justifyContent: 'center',
    //   marginLeft: 'auto',
    //   marginRight: 'auto',
    // },
    // paddingBottom: '100px',
  },
  pageContent: ({ navigationOpen, disableDrawerMargin, disableDrawerMarginOnMdDown }) => {
    const shouldDisableMarginOnDesktop = disableDrawerMargin;

    return {
      // paddingTop: '85px',
      // Desktop: apply drawer margin unless disabled
      marginLeft: navigationOpen && !shouldDisableMarginOnDesktop ? `${drawerWidth}px` : 0,
      // Mobile/Tablet: drawer is temporary (overlay), so no margin needed
      [theme.breakpoints.down('md')]: {
        marginLeft: 0,
      },
      transition: navigationOpen ? 'margin-left 0.25s' : 'margin-left 0.3s',

      [theme.breakpoints.down('sm')]: {
        // marginLeft: '20px',
        // paddingTop: '175px',
      },
    };
  },
}));

export default useStyles;
